/**
 * In-memory access token store.
 * Keeps the short-lived access token out of localStorage (XSS mitigation).
 * The refresh token lives in an httpOnly cookie managed by the server.
 */

let _accessToken = null;

export function getToken() {
  return _accessToken;
}

export function setToken(token) {
  _accessToken = token || null;
}

export function clearToken() {
  _accessToken = null;
}
